// TODO: Вынести - возможно в свойства схемы и добавить дефолтный если не будет указана страна
export const COUNTRIES_CODE: Array<string> = ["ru", "by", "kz", "md"];

export const ERRORS_MESSAGES = {
    403: "Доступ запрещён",
    404: "Значение не найдено",
    423: "Изменение поля запрещено",
    500: "Внутренняя ошибка сервера",
};
